import { render } from "./InfoCollection.vue?vue&type=template&id=1c549088&scoped=true"
import script from "./InfoCollection.vue?vue&type=script&lang=js"
export * from "./InfoCollection.vue?vue&type=script&lang=js"

import "./InfoCollection.vue?vue&type=style&index=0&id=1c549088&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c549088"]])

export default __exports__